import { render, staticRenderFns } from "./baoyang.vue?vue&type=template&id=e220ea08"
import script from "./baoyang.vue?vue&type=script&lang=js"
export * from "./baoyang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports